import React, { Component } from 'react';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { Card } from '@material-ui/core';
import TableWithPagination from '../Table/TableWithPagination';
import { downloadQuote, setFilteredAndSortedQuotes } from '../../redux/quote/quoteActions'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { MODULE_EXTRANET_QUOTES } from '../../redux/authorizedApps/authorizedAppsConstants';
import { loadAffair } from '../../redux/affair/affairActions';
import { getAffair } from '../../redux/affair/extranetAffairActions';

class QuotesAsTable extends Component {

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row && rowInfo.row._original && rowInfo.row._original.created_affair_id) {
            return {
                onClick: this.getAffair.bind(this, rowInfo.row._original.created_affair_id),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    getAffair(affairCode) {
        this.props.getAffair(affairCode, this.props.activeUser.id, this.props.sites.selectedSite, this.props.sites.sites, (affair) => {
            this.props.loadAffair(affair);
            this.props.history.push("/affairs/affair");
            this.props.globalContainer.current.scrollTop = 0;
        });
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <Card>
                <TableWithPagination
                    data={this.props.filteredAndSortedQuotes.filter((a) => !a.deleted)}
                    columns={this.props.columns} manual getTrProps={this.getTableTrProps.bind(this)}
                    pages={Math.ceil(this.props.tableState.nbTotalResults[MODULE_EXTRANET_QUOTES] / this.props.tableState.pageSize)}
                    onFetchData={(state) => {
                        let tableState = {
                            pageSize: state.pageSize,
                            pageNumber: state.page,
                            orderBy: state.sorted.length > 0 ? state.sorted[0].id : "",
                            descOrder: state.sorted.length > 0 ? state.sorted[0].desc : false
                        }

                        this.props.setFilteredAndSortedQuotes(this.props.quotes, tableState, this.props.activeUser,
                            this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);
                    }}
                />
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        quotes: state.quotes,
        activeUser: state.activeUser,
        tableState: state.tableState,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilteredAndSortedQuotes: (quotesFilters, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedQuotes(quotesFilters, tableState, user, customerSiteId, allSites, nbTotalResults)),
        downloadQuote: (quote, user) => dispatch(downloadQuote(quote, user)),
        getAffair: (affairCode, userId, customerSiteId, allSites, onSuccess) => dispatch(getAffair(affairCode, userId, customerSiteId, allSites, onSuccess)),
        loadAffair: (affair) => dispatch(loadAffair(affair)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(QuotesAsTable);
